import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  inject,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProgressBarComponent implements OnInit {
  private _host = inject(ElementRef);
  private _renderer = inject(Renderer2);

  private readonly cdr = inject(ChangeDetectorRef);

  readonly progress = input.required<Observable<number>>();

  public start = true;

  public updating = false;

  public complete = false;

  ngOnInit() {
    this.progress().subscribe((value) => {
      this.cdr.markForCheck();
      this.complete = value === 100;
      this.start = value <= 1;
      this.updating = !(this.start || this.complete);

      this.toggleClass('start', this.start);
      this.toggleClass('complete', this.complete);
      this.toggleClass('updating', this.updating);
      this._renderer.setStyle(this._host.nativeElement, 'width', `${value}%`);
    });
  }

  private toggleClass(name: string, present: boolean) {
    if (present) {
      this._renderer.addClass(this._host.nativeElement, name);
    } else {
      this._renderer.removeClass(this._host.nativeElement, name);
    }
  }
}
